// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type {
	PendingDataState,
	RequestTypeFormData,
	TicketTypeData,
} from '../../../common/types.tsx';

const setRequestTypeFormData =
	(requestTypeFormData: PendingDataState<RequestTypeFormData>): Action<TicketTypeData> =>
	({ setState }) => {
		setState({
			requestTypeFormData,
		});
	};

export default setRequestTypeFormData;
